"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.darkColors = exports.darkPalette = void 0;
const light_1 = require("./light");
const invariant_1 = require("./invariant");
// TODO: Atm we don't have dark mode colors and we use the same as light mode as placeholder
// The specific colors for the dark theme
exports.darkPalette = {
    ...light_1.lightPalette
};
// All the dark colors, including also the invariant ones
exports.darkColors = {
    ...exports.darkPalette,
    ...invariant_1.invariantColors
};
